export const ZipCodeList = [
    { province: "Abra", city: "Bangued", zipCode: "2800", },
    { province: "Abra", city: "Boliney", zipCode: "2815", },
    { province: "Abra", city: "Bucay", zipCode: "2805", },
    { province: "Abra", city: "Bucloc", zipCode: "2817", },
    { province: "Abra", city: "Daguioman", zipCode: "2816", },
    { province: "Abra", city: "Danglas", zipCode: "2825", },
    { province: "Abra", city: "Dolores", zipCode: "2801", },
    { province: "Abra", city: "La Paz", zipCode: "2826", },
    { province: "Abra", city: "Lacub", zipCode: "2821", },
    { province: "Abra", city: "Lagangilang", zipCode: "2802", },
    { province: "Abra", city: "Lagayan", zipCode: "2824", },
    { province: "Abra", city: "Langiden", zipCode: "2807", },
    { province: "Abra", city: "Licuan-Baay (Licuan)", zipCode: "2819", },
    { province: "Abra", city: "Luba", zipCode: "2813", },
    { province: "Abra", city: "Malibcong", zipCode: "2820", },
    { province: "Abra", city: "Manabo", zipCode: "2810", },
    { province: "Abra", city: "Peñarrubia", zipCode: "2804", },
    { province: "Abra", city: "Pidigan", zipCode: "2806", },
    { province: "Abra", city: "Pilar", zipCode: "2812", },
    { province: "Abra", city: "Sallapadan", zipCode: "2818", },
    { province: "Abra", city: "San Isidro", zipCode: "2809", },
    { province: "Abra", city: "San Juan", zipCode: "2823", },
    { province: "Abra", city: "San Quintin", zipCode: "2808", },
    { province: "Abra", city: "Tayum", zipCode: "2803", },
    { province: "Abra", city: "Tineg", zipCode: "2822", },
    { province: "Abra", city: "Tubo", zipCode: "2814", },
    { province: "Abra", city: "Villaviciosa", zipCode: "2811", },
    { province: "Agusan del Norte", city: "Buenavista", zipCode: "8601", },
    { province: "Agusan del Norte", city: "Butuan", zipCode: "8600", },
    { province: "Agusan del Norte", city: "Cabadbaran", zipCode: "8605", },
    { province: "Agusan del Norte", city: "Carmen", zipCode: "8603", },
    { province: "Agusan del Norte", city: "Jabonga", zipCode: "8607", },
    { province: "Agusan del Norte", city: "Kitcharao", zipCode: "8609", },
    { province: "Agusan del Norte", city: "Las Nieves", zipCode: "8610", },
    { province: "Agusan del Norte", city: "Magallanes", zipCode: "8604", },
    { province: "Agusan del Norte", city: "Nasipit", zipCode: "8602", },
    { province: "Agusan del Norte", city: "Remedios T. Romualdez", zipCode: "8611", },
    { province: "Agusan del Norte", city: "Santiago", zipCode: "8608", },
    { province: "Agusan del Norte", city: "Tubay", zipCode: "8606", },
    { province: "Agusan del Sur", city: "Bayugan", zipCode: "8502", },
    { province: "Agusan del Sur", city: "Bunawan", zipCode: "8506", },
    { province: "Agusan del Sur", city: "Esperanza", zipCode: "8513", },
    { province: "Agusan del Sur", city: "La Paz", zipCode: "8508", },
    { province: "Agusan del Sur", city: "Loreto", zipCode: "8507", },
    { province: "Agusan del Sur", city: "Prosperidad", zipCode: "8500", },
    { province: "Agusan del Sur", city: "Rosario", zipCode: "8504", },
    { province: "Agusan del Sur", city: "San Francisco", zipCode: "8501", },
    { province: "Agusan del Sur", city: "San Luis", zipCode: "8511", },
    { province: "Agusan del Sur", city: "Santa Josefa", zipCode: "8512", },
    { province: "Agusan del Sur", city: "Sibagat", zipCode: "8503", },
    { province: "Agusan del Sur", city: "Talacogon", zipCode: "8510", },
    { province: "Agusan del Sur", city: "Trento", zipCode: "8505", },
    { province: "Agusan del Sur", city: "Veruela", zipCode: "8509", },
    { province: "Aklan", city: "Altavas", zipCode: "5616", },
    { province: "Aklan", city: "Balete", zipCode: "5614", },
    { province: "Aklan", city: "Banga", zipCode: "5601", },
    { province: "Aklan", city: "Batan", zipCode: "5615", },
    { province: "Aklan", city: "Buruanga", zipCode: "5609", },
    { province: "Aklan", city: "Ibajay", zipCode: "5613", },
    { province: "Aklan", city: "Kalibo", zipCode: "5600", },
    { province: "Aklan", city: "Lezo", zipCode: "5605", },
    { province: "Aklan", city: "Libacao", zipCode: "5602", },
    { province: "Aklan", city: "Madalag", zipCode: "5603", },
    { province: "Aklan", city: "Makato", zipCode: "5611", },
    { province: "Aklan", city: "Malay", zipCode: "5608", },
    { province: "Aklan", city: "Malinao", zipCode: "5606", },
    { province: "Aklan", city: "Nabas", zipCode: "5607", },
    { province: "Aklan", city: "New Washington", zipCode: "5610", },
    { province: "Aklan", city: "Numancia", zipCode: "5604", },
    { province: "Aklan", city: "Tangalan", zipCode: "5612", },
    { province: "Albay", city: "Bacacay", zipCode: "4509", },
    { province: "Albay", city: "Camalig", zipCode: "4502", },
    { province: "Albay", city: "Daraga", zipCode: "4501", },
    { province: "Albay", city: "Guinobatan", zipCode: "4503", },
    { province: "Albay", city: "Jovellar", zipCode: "4515", },
    { province: "Albay", city: "Legazpi City", zipCode: "4500", },
    { province: "Albay", city: "Libon", zipCode: "4507", },
    { province: "Albay", city: "Ligao", zipCode: "4504", },
    { province: "Albay", city: "Malilipot", zipCode: "4510", },
    { province: "Albay", city: "Malinao", zipCode: "4512", },
    { province: "Albay", city: "Manito", zipCode: "4514", },
    { province: "Albay", city: "Oas", zipCode: "4504", },
    { province: "Albay", city: "Pio Duran", zipCode: "4516", },
    { province: "Albay", city: "Polangui", zipCode: "4506", },
    { province: "Albay", city: "Rapu-Rapu", zipCode: "4517", },
    { province: "Albay", city: "Santo Domingo", zipCode: "4508", },
    { province: "Albay", city: "Tabaco", zipCode: "4511", },
    { province: "Albay", city: "Tiwi", zipCode: "4513", },
    { province: "Antique", city: "Anini-y", zipCode: "5717", },
    { province: "Antique", city: "Barbaza", zipCode: "5706", },
    { province: "Antique", city: "Belison", zipCode: "5701", },
    { province: "Antique", city: "Bugasong", zipCode: "5704", },
    { province: "Antique", city: "Caluya", zipCode: "5711", },
    { province: "Antique", city: "Culasi", zipCode: "5708", },
    { province: "Antique", city: "Hamtic", zipCode: "5715", },
    { province: "Antique", city: "Laua-an", zipCode: "5705", },
    { province: "Antique", city: "Libertad", zipCode: "5710", },
    { province: "Antique", city: "Pandan", zipCode: "5712", },
    { province: "Antique", city: "Patnongon", zipCode: "5702", },
    { province: "Antique", city: "San Jose de Buenavista", zipCode: "5700", },
    { province: "Antique", city: "San Remigio", zipCode: "5714", },
    { province: "Antique", city: "Sebaste", zipCode: "5709", },
    { province: "Antique", city: "Sibalom", zipCode: "5713", },
    { province: "Antique", city: "Tibiao", zipCode: "5707", },
    { province: "Antique", city: "Tobias Fornier", zipCode: "5716", },
    { province: "Antique", city: "Valderrama", zipCode: "5703", },
    { province: "Apayao", city: "Calanasan", zipCode: "3814", },
    { province: "Apayao", city: "Conner", zipCode: "3807", },
    { province: "Apayao", city: "Flora", zipCode: "3807", },
    { province: "Apayao", city: "Kabugao", zipCode: "3809", },
    { province: "Apayao", city: "Luna", zipCode: "3813", },
    { province: "Apayao", city: "Pudtol", zipCode: "3812", },
    { province: "Apayao", city: "Santa Marcela", zipCode: "3811", },
    { province: "Aurora", city: "Baler", zipCode: "3200", },
    { province: "Aurora", city: "Casiguran", zipCode: "3204", },
    { province: "Aurora", city: "Dilasag", zipCode: "3205", },
    { province: "Aurora", city: "Dinalungan", zipCode: "3206", },
    { province: "Aurora", city: "Dingalan", zipCode: "3207", },
    { province: "Aurora", city: "Dipaculao", zipCode: "3203", },
    { province: "Aurora", city: "Maria Aurora", zipCode: "3202", },
    { province: "Aurora", city: "San Luis", zipCode: "3201", },
    // { province: "Basilan", city: "", zipCode: "", },
    { province: "Bataan", city: "Abucay", zipCode: "2114", },
    { province: "Bataan", city: "Bagac", zipCode: "2107", },
    { province: "Bataan", city: "Balanga", zipCode: "2100", },
    { province: "Bataan", city: "Dinalupihan", zipCode: "2110", },
    { province: "Bataan", city: "Hermosa", zipCode: "2111", },
    { province: "Bataan", city: "Limay", zipCode: "2103", },
    { province: "Bataan", city: "Mariveles", zipCode: "2105", },
    { province: "Bataan", city: "Morong", zipCode: "2108", },
    { province: "Bataan", city: "Orani", zipCode: "2112", },
    { province: "Bataan", city: "Orion", zipCode: "2102", },
    { province: "Bataan", city: "Pilar", zipCode: "2101", },
    { province: "Bataan", city: "Samal", zipCode: "2113", },
    // { province: "Batanes", city: "", zipCode: "", },
    { province: "Batangas", city: "Agoncillo", zipCode: "4211", },
    { province: "Batangas", city: "Alitagtag", zipCode: "4205", },
    { province: "Batangas", city: "Balayan", zipCode: "4213", },
    { province: "Batangas", city: "Balete", zipCode: "4219", },
    { province: "Batangas", city: "Batangas City", zipCode: "4200", },
    { province: "Batangas", city: "Bauan", zipCode: "4201", },
    { province: "Batangas", city: "Calaca", zipCode: "4212", },
    { province: "Batangas", city: "Calatagan", zipCode: "4215", },
    { province: "Batangas", city: "Cuenca", zipCode: "4222", },
    { province: "Batangas", city: "Ibaan", zipCode: "4230", },
    { province: "Batangas", city: "Laurel", zipCode: "4221", },
    { province: "Batangas", city: "Lemery", zipCode: "4209", },
    { province: "Batangas", city: "Lian", zipCode: "4216", },
    { province: "Batangas", city: "Lipa", zipCode: "4217", },
    { province: "Batangas", city: "Lobo", zipCode: "4229", },
    { province: "Batangas", city: "Mabini", zipCode: "4202", },
    { province: "Batangas", city: "Malvar", zipCode: "4233", },
    { province: "Batangas", city: "Mataas na kahoy", zipCode: "4223", },
    { province: "Batangas", city: "Nasugbu", zipCode: "4231", },
    { province: "Batangas", city: "Padre Garcia", zipCode: "4224", },
    { province: "Batangas", city: "Rosario", zipCode: "4225", },
    { province: "Batangas", city: "San Jose", zipCode: "4227", },
    { province: "Batangas", city: "San Juan", zipCode: "4226", },
    { province: "Batangas", city: "San Luis", zipCode: "4210", },
    { province: "Batangas", city: "San Nicolas", zipCode: "4207", },
    { province: "Batangas", city: "San Pascual", zipCode: "4204", },
    { province: "Batangas", city: "Santa Teresita", zipCode: "4206", },
    { province: "Batangas", city: "Santo Tomas", zipCode: "4234", },
    { province: "Batangas", city: "Taal", zipCode: "4208", },
    { province: "Batangas", city: "Talisay", zipCode: "4220", },
    { province: "Batangas", city: "Tanauan", zipCode: "4232", },
    { province: "Batangas", city: "Taysan", zipCode: "4228", },
    { province: "Batangas", city: "Tingloy", zipCode: "4203", },
    { province: "Batangas", city: "Tuy", zipCode: "4214", },
    // { province: "Benguet", city: "", zipCode: "", },
    // { province: "Biliran", city: "", zipCode: "", },
    // { province: "Bohol", city: "", zipCode: "", },
    // { province: "Bukidnon", city: "", zipCode: "", },
    { province: "Bulacan", city: "Angat", zipCode: "3012", },
    { province: "Bulacan", city: "Balagtas", zipCode: "3016", },
    { province: "Bulacan", city: "Baliuag", zipCode: "3006", },
    { province: "Bulacan", city: "Bocaue", zipCode: "3018", },
    { province: "Bulacan", city: "Bulacan", zipCode: "3017", },
    { province: "Bulacan", city: "Bustos", zipCode: "3007", },
    { province: "Bulacan", city: "Calumpit", zipCode: "3003", },
    { province: "Bulacan", city: "Doña Remedios Trinidad", zipCode: "3009", },
    { province: "Bulacan", city: "Guiguinto", zipCode: "3015", },
    { province: "Bulacan", city: "Hagonoy", zipCode: "3002", },
    { province: "Bulacan", city: "Malolos", zipCode: "3000", },
    { province: "Bulacan", city: "Marilao", zipCode: "3019", },
    { province: "Bulacan", city: "Meycauayan", zipCode: "3020", },
    { province: "Bulacan", city: "Norzagaray", zipCode: "3013", },
    { province: "Bulacan", city: "Obando", zipCode: "3021", },
    { province: "Bulacan", city: "Pandi", zipCode: "3014", },
    { province: "Bulacan", city: "Paombong", zipCode: "3001", },
    { province: "Bulacan", city: "Plaridel", zipCode: "3004", },
    { province: "Bulacan", city: "Pulilan", zipCode: "3005", },
    { province: "Bulacan", city: "San Ildefonso", zipCode: "3010", },
    { province: "Bulacan", city: "San Jose del Monte", zipCode: "3023", },
    { province: "Bulacan", city: "San Miguel", zipCode: "3011", },
    { province: "Bulacan", city: "San Rafael", zipCode: "3008", },
    { province: "Bulacan", city: "Santa Maria", zipCode: "3022", },
    // { province: "Cagayan", city: "", zipCode: "", },
    // { province: "Camarines Norte", city: "", zipCode: "", },
    { province: "Camarines Sur", city: "Baao", zipCode: "4432", },
    { province: "Camarines Sur", city: "Balatan", zipCode: "4436", },
    { province: "Camarines Sur", city: "Bato", zipCode: "4435", },
    { province: "Camarines Sur", city: "Bombon", zipCode: "4404", },
    { province: "Camarines Sur", city: "Buhi", zipCode: "4433", },
    { province: "Camarines Sur", city: "Bula", zipCode: "4430", },
    { province: "Camarines Sur", city: "Cabusao", zipCode: "4406", },
    { province: "Camarines Sur", city: "Calabanga", zipCode: "4405", },
    { province: "Camarines Sur", city: "Camaligan", zipCode: "4401", },
    { province: "Camarines Sur", city: "Canaman", zipCode: "4402", },
    { province: "Camarines Sur", city: "Caramoan", zipCode: "4429", },
    { province: "Camarines Sur", city: "Del Gallego", zipCode: "4411", },
    { province: "Camarines Sur", city: "Gainza", zipCode: "4412", },
    { province: "Camarines Sur", city: "Garchitorena", zipCode: "4428", },
    { province: "Camarines Sur", city: "Goa", zipCode: "4422", },
    { province: "Camarines Sur", city: "Iriga", zipCode: "4431", },
    { province: "Camarines Sur", city: "Lagonoy", zipCode: "4425", },
    { province: "Camarines Sur", city: "Libmanan", zipCode: "4407", },
    { province: "Camarines Sur", city: "Lupi", zipCode: "4409", },
    { province: "Camarines Sur", city: "Magarao", zipCode: "4403", },
    { province: "Camarines Sur", city: "Milaor", zipCode: "4413", },
    { province: "Camarines Sur", city: "Minalabac", zipCode: "4414", },
    { province: "Camarines Sur", city: "Nabua", zipCode: "4434", },
    { province: "Camarines Sur", city: "Naga", zipCode: "4400", },
    { province: "Camarines Sur", city: "Ocampo", zipCode: "4419", },
    { province: "Camarines Sur", city: "Pamplona", zipCode: "4416", },
    { province: "Camarines Sur", city: "Pasacao", zipCode: "4417", },
    { province: "Camarines Sur", city: "Pili", zipCode: "4418", },
    { province: "Camarines Sur", city: "Presentacion", zipCode: "4424", },
    { province: "Camarines Sur", city: "Ragay", zipCode: "4410", },
    { province: "Camarines Sur", city: "Sagñay", zipCode: "4421", },
    { province: "Camarines Sur", city: "San Fernando", zipCode: "4415", },
    { province: "Camarines Sur", city: "San Jose", zipCode: "4423", },
    { province: "Camarines Sur", city: "Sipocot", zipCode: "4408", },
    { province: "Camarines Sur", city: "Siruma", zipCode: "4427", },
    { province: "Camarines Sur", city: "Tigaon", zipCode: "4420", },
    { province: "Camarines Sur", city: "Tinambac", zipCode: "4426", },
    // { province: "Camiguin", city: "", zipCode: "", },
    // { province: "Capiz", city: "", zipCode: "", },
    // { province: "Catanduanes", city: "", zipCode: "", },
    { province: "Cavite", city: "Alfonso", zipCode: "4123", },
    { province: "Cavite", city: "Amadeo", zipCode: "4119", },
    { province: "Cavite", city: "Bacoor", zipCode: "4102", },
    { province: "Cavite", city: "Carmona", zipCode: "4116", },
    { province: "Cavite", city: "Cavite City", zipCode: "4100", },
    { province: "Cavite", city: "Dasmariñas", zipCode: "4114", },
    { province: "Cavite", city: "General Emilio Aguinaldo", zipCode: "4124", },
    { province: "Cavite", city: "General Mariano Alvarez", zipCode: "4117", },
    { province: "Cavite", city: "General Trias", zipCode: "4107", },
    { province: "Cavite", city: "Imus", zipCode: "4103", },
    { province: "Cavite", city: "Indang", zipCode: "4122", },
    { province: "Cavite", city: "Kawit", zipCode: "4104", },
    { province: "Cavite", city: "Magallanes", zipCode: "4113", },
    { province: "Cavite", city: "Maragondon", zipCode: "4112", },
    { province: "Cavite", city: "Mendez", zipCode: "4121", },
    { province: "Cavite", city: "Naic", zipCode: "4110", },
    { province: "Cavite", city: "Noveleta", zipCode: "4105", },
    { province: "Cavite", city: "Rosario", zipCode: "4106", },
    { province: "Cavite", city: "Silang", zipCode: "4118", },
    { province: "Cavite", city: "Tagaytay", zipCode: "4120", },
    { province: "Cavite", city: "Tanza", zipCode: "4108", },
    { province: "Cavite", city: "Ternate", zipCode: "4111", },
    { province: "Cavite", city: "Trece Martires", zipCode: "4109", },
    { province: "Cebu", city: "Alcantara", zipCode: "6033", },
    { province: "Cebu", city: "Alcoy", zipCode: "6023", },
    { province: "Cebu", city: "Alegria", zipCode: "6030", },
    { province: "Cebu", city: "Aloguinsan", zipCode: "6040", },
    { province: "Cebu", city: "Argao", zipCode: "6021", },
    { province: "Cebu", city: "Asturias", zipCode: "6042", },
    { province: "Cebu", city: "Badian", zipCode: "6031", },
    { province: "Cebu", city: "Balamban", zipCode: "6041", },
    { province: "Cebu", city: "Bantayan", zipCode: "6042", },
    { province: "Cebu", city: "Barili", zipCode: "6036", },
    { province: "Cebu", city: "Bogo", zipCode: "6010", },
    { province: "Cebu", city: "Boljoon", zipCode: "6024", },
    { province: "Cebu", city: "Borbon", zipCode: "6008", },
    { province: "Cebu", city: "Carcar", zipCode: "6019", },
    { province: "Cebu", city: "Carmen", zipCode: "6005", },
    { province: "Cebu", city: "Catmon", zipCode: "6006", },
    { province: "Cebu", city: "Cebu City", zipCode: "6000", },
    { province: "Cebu", city: "Compostela", zipCode: "6003", },
    { province: "Cebu", city: "Consolacion", zipCode: "6001", },
    { province: "Cebu", city: "Cordova", zipCode: "6017", },
    { province: "Cebu", city: "Daanbantayan", zipCode: "6013", },
    { province: "Cebu", city: "Dalaguete", zipCode: "6022", },
    { province: "Cebu", city: "Danao", zipCode: "6004", },
    { province: "Cebu", city: "Dumanjug", zipCode: "6035", },
    { province: "Cebu", city: "Ginatilan", zipCode: "6026", },
    { province: "Cebu", city: "Lapu-Lapu City", zipCode: "6015", },
    { province: "Cebu", city: "Liloan", zipCode: "6002", },
    { province: "Cebu", city: "Madridejos", zipCode: "6016", },
    { province: "Cebu", city: "Malabuyoc", zipCode: "6029", },
    { province: "Cebu", city: "Mandaue", zipCode: "6014", },
    { province: "Cebu", city: "Medellin", zipCode: "6012", },
    { province: "Cebu", city: "Minglanilla", zipCode: "6046", },
    { province: "Cebu", city: "Moalboal", zipCode: "6032", },
    { province: "Cebu", city: "Naga", zipCode: "6037", },
    { province: "Cebu", city: "Oslob", zipCode: "6025", },
    { province: "Cebu", city: "Pilar", zipCode: "6048", },
    { province: "Cebu", city: "Pinamungajan", zipCode: "6039", },
    { province: "Cebu", city: "Poro", zipCode: "6049", },
    { province: "Cebu", city: "Ronda", zipCode: "6034", },
    { province: "Cebu", city: "Samboan", zipCode: "6027", },
    { province: "Cebu", city: "San Fernando", zipCode: "6018", },
    { province: "Cebu", city: "San Francisco", zipCode: "6050", },
    { province: "Cebu", city: "San Remigio", zipCode: "6011", },
    { province: "Cebu", city: "Santa Fe", zipCode: "6047", },
    { province: "Cebu", city: "Santander", zipCode: "6026", },
    { province: "Cebu", city: "Sibonga", zipCode: "6020", },
    { province: "Cebu", city: "Sogod", zipCode: "6007", },
    { province: "Cebu", city: "Tabogon", zipCode: "6009", },
    { province: "Cebu", city: "Tabuelan", zipCode: "6044", },
    { province: "Cebu", city: "Talisay", zipCode: "6045", },
    { province: "Cebu", city: "Toledo", zipCode: "6038", },
    { province: "Cebu", city: "Tuburan", zipCode: "6043", },
    { province: "Cebu", city: "Tudela", zipCode: "6051", },
    // { province: "Cotabato", city: "", zipCode: "", },
    // { province: "Davao de Oro", city: "", zipCode: "", },
    // { province: "Davao del Norte", city: "", zipCode: "", },
    // { province: "Davao del Sur", city: "", zipCode: "", },
    // { province: "Davao Occidental", city: "", zipCode: "", },
    // { province: "Davao Oriental", city: "", zipCode: "", },
    // { province: "Dinagat Islands", city: "", zipCode: "", },
    // { province: "Eastern Samar", city: "", zipCode: "", },
    // { province: "Guimaras", city: "", zipCode: "", },
    // { province: "Ifugao", city: "", zipCode: "", },
    // { province: "Ilocos Norte", city: "", zipCode: "", },
    // { province: "Ilocos Sur", city: "", zipCode: "", },
    { province: "Iloilo", city: "Ajuy", zipCode: "5012", },
    { province: "Iloilo", city: "Alimodian", zipCode: "5028", },
    { province: "Iloilo", city: "Anilao", zipCode: "5009", },
    { province: "Iloilo", city: "Badiangan", zipCode: "5033", },
    { province: "Iloilo", city: "Balasan", zipCode: "5018", },
    { province: "Iloilo", city: "Banate", zipCode: "5010", },
    { province: "Iloilo", city: "Barotac Nuevo", zipCode: "5007", },
    { province: "Iloilo", city: "Barotac Viejo", zipCode: "5011", },
    { province: "Iloilo", city: "Batad", zipCode: "5016", },
    { province: "Iloilo", city: "Bingawan", zipCode: "5041", },
    { province: "Iloilo", city: "Cabatuan", zipCode: "5031", },
    { province: "Iloilo", city: "Calinog", zipCode: "5040", },
    { province: "Iloilo", city: "Carles", zipCode: "5019", },
    { province: "Iloilo", city: "Concepcion", zipCode: "5013", },
    { province: "Iloilo", city: "Dingle", zipCode: "5035", },
    { province: "Iloilo", city: "Dueñas", zipCode: "5038", },
    { province: "Iloilo", city: "Dumangas", zipCode: "5006", },
    { province: "Iloilo", city: "Estancia", zipCode: "5017", },
    { province: "Iloilo", city: "Guimbal", zipCode: "5022", },
    { province: "Iloilo", city: "Igbaras", zipCode: "5029", },
    { province: "Iloilo", city: "Iloilo City", zipCode: "5000", },
    { province: "Iloilo", city: "Janiuay", zipCode: "5034", },
    { province: "Iloilo", city: "Lambunao", zipCode: "5042", },
    { province: "Iloilo", city: "Leganes", zipCode: "5003", },
    { province: "Iloilo", city: "Lemery", zipCode: "5043", },
    { province: "Iloilo", city: "Leon", zipCode: "5026", },
    { province: "Iloilo", city: "Maasin", zipCode: "5030", },
    { province: "Iloilo", city: "Miagao", zipCode: "5023", },
    { province: "Iloilo", city: "Mina", zipCode: "5032", },
    { province: "Iloilo", city: "New Lucena", zipCode: "5005", },
    { province: "Iloilo", city: "Oton", zipCode: "5020", },
    { province: "Iloilo", city: "Passi", zipCode: "5037", },
    { province: "Iloilo", city: "Pavia", zipCode: "5001", },
    { province: "Iloilo", city: "Pototan", zipCode: "5008", },
    { province: "Iloilo", city: "San Dionisio", zipCode: "5015", },
    { province: "Iloilo", city: "San Enrique", zipCode: "5036", },
    { province: "Iloilo", city: "San Joaquin", zipCode: "5024", },
    { province: "Iloilo", city: "San Miguel", zipCode: "5025", },
    { province: "Iloilo", city: "San Rafael", zipCode: "5039", },
    { province: "Iloilo", city: "Santa Barbara", zipCode: "5002", },
    { province: "Iloilo", city: "Sara", zipCode: "5014", },
    { province: "Iloilo", city: "Tigbauan", zipCode: "5021", },
    { province: "Iloilo", city: "Tubungan", zipCode: "5027", },
    { province: "Iloilo", city: "Zarraga", zipCode: "5004", },
    // { province: "Isabela", city: "", zipCode: "", },
    // { province: "Kalinga", city: "", zipCode: "", },
    // { province: "La Union", city: "", zipCode: "", },
    { province: "Laguna", city: "Alaminos", zipCode: "4001", },
    { province: "Laguna", city: "Bay", zipCode: "4033", },
    { province: "Laguna", city: "Biñan", zipCode: "4024", },
    { province: "Laguna", city: "Cabuyao", zipCode: "4025", },
    { province: "Laguna", city: "Calamba", zipCode: "4027", },
    { province: "Laguna", city: "Calauan", zipCode: "4012", },
    { province: "Laguna", city: "Cavinti", zipCode: "4013", },
    { province: "Laguna", city: "Famy", zipCode: "4021", },
    { province: "Laguna", city: "Kalayaan", zipCode: "4015", },
    { province: "Laguna", city: "Liliw", zipCode: "4004", },
    { province: "Laguna", city: "Los Baños", zipCode: "4030", },
    { province: "Laguna", city: "Luisiana", zipCode: "4032", },
    { province: "Laguna", city: "Lumban", zipCode: "4014", },
    { province: "Laguna", city: "Mabitac", zipCode: "4020", },
    { province: "Laguna", city: "Magdalena", zipCode: "4007", },
    { province: "Laguna", city: "Majayjay", zipCode: "4005", },
    { province: "Laguna", city: "Nagcarlan", zipCode: "4002", },
    { province: "Laguna", city: "Paete", zipCode: "4016", },
    { province: "Laguna", city: "Pagsanjan", zipCode: "4008", },
    { province: "Laguna", city: "Pakil", zipCode: "4017", },
    { province: "Laguna", city: "Pangil", zipCode: "4018", },
    { province: "Laguna", city: "Pila", zipCode: "4010", },
    { province: "Laguna", city: "Rizal", zipCode: "4003", },
    { province: "Laguna", city: "San Pablo", zipCode: "4000", },
    { province: "Laguna", city: "San Pedro", zipCode: "4023", },
    { province: "Laguna", city: "Santa Cruz", zipCode: "4009", },
    { province: "Laguna", city: "Santa Maria", zipCode: "4022", },
    { province: "Laguna", city: "Santa Rosa", zipCode: "4026", },
    { province: "Laguna", city: "Siniloan", zipCode: "4019", },
    { province: "Laguna", city: "Victoria", zipCode: "4011", },
    // { province: "Lanao del Norte", city: "", zipCode: "", },
    // { province: "Lanao del Sur", city: "", zipCode: "", },
    { province: "Leyte", city: "Abuyog", zipCode: "6510", },
    { province: "Leyte", city: "Alangalang", zipCode: "6517", },
    { province: "Leyte", city: "Albuera", zipCode: "6542", },
    { province: "Leyte", city: "Babatngon", zipCode: "6520", },
    { province: "Leyte", city: "Barugo", zipCode: "6519", },
    { province: "Leyte", city: "Bato", zipCode: "6525", },
    { province: "Leyte", city: "Baybay", zipCode: "6521", },
    { province: "Leyte", city: "Burauen", zipCode: "6516", },
    { province: "Leyte", city: "Calubian", zipCode: "6534", },
    { province: "Leyte", city: "Capoocan", zipCode: "6530", },
    { province: "Leyte", city: "Carigara", zipCode: "6529", },
    { province: "Leyte", city: "Dagami", zipCode: "6515", },
    { province: "Leyte", city: "Dulag", zipCode: "6505", },
    { province: "Leyte", city: "Hilongos", zipCode: "6524", },
    { province: "Leyte", city: "Hindang", zipCode: "6523", },
    { province: "Leyte", city: "Inopacan", zipCode: "6522", },
    { province: "Leyte", city: "Isabel", zipCode: "6539", },
    { province: "Leyte", city: "Jaro", zipCode: "6527", },
    { province: "Leyte", city: "Javier (Bugho)", zipCode: "6511", },
    { province: "Leyte", city: "Julita", zipCode: "6506", },
    { province: "Leyte", city: "Kananga", zipCode: "6531", },
    { province: "Leyte", city: "La Paz", zipCode: "6508", },
    { province: "Leyte", city: "Leyte", zipCode: "6533", },
    { province: "Leyte", city: "MacArthur", zipCode: "6509", },
    { province: "Leyte", city: "Mahaplag", zipCode: "6512", },
    { province: "Leyte", city: "Matag-ob", zipCode: "6532", },
    { province: "Leyte", city: "Matalom", zipCode: "6526", },
    { province: "Leyte", city: "Mayorga", zipCode: "6507", },
    { province: "Leyte", city: "Merida", zipCode: "6540", },
    { province: "Leyte", city: "Ormoc", zipCode: "6541", },
    { province: "Leyte", city: "Palo", zipCode: "6501", },
    { province: "Leyte", city: "Palompon", zipCode: "6538", },
    { province: "Leyte", city: "Pastrana", zipCode: "6514", },
    { province: "Leyte", city: "San Isidro", zipCode: "6535", },
    { province: "Leyte", city: "San Miguel", zipCode: "6518", },
    { province: "Leyte", city: "Santa Fe", zipCode: "6513", },
    { province: "Leyte", city: "Tabango", zipCode: "6536", },
    { province: "Leyte", city: "Tabontabon", zipCode: "6504", },
    { province: "Leyte", city: "Tacloban", zipCode: "6500", },
    { province: "Leyte", city: "Tanauan", zipCode: "6502", },
    { province: "Leyte", city: "Tolosa", zipCode: "6503", },
    { province: "Leyte", city: "Tunga", zipCode: "6528", },
    { province: "Leyte", city: "Villaba", zipCode: "6537", },
    // { province: "Maguindanao", city: "", zipCode: "", },
    // { province: "Marinduque", city: "", zipCode: "", },
    // { province: "Masbate", city: "", zipCode: "", },
    { province: "Misamis Occidental", city: "Aloran", zipCode: "7206", },
    { province: "Misamis Occidental", city: "Baliangao", zipCode: "7211", },
    { province: "Misamis Occidental", city: "Bonifacio", zipCode: "7215", },
    { province: "Misamis Occidental", city: "Calamba", zipCode: "7210", },
    { province: "Misamis Occidental", city: "Clarin", zipCode: "7201", },
    { province: "Misamis Occidental", city: "Concepcion", zipCode: "7213", },
    { province: "Misamis Occidental", city: "Don Victoriano Chiongbian", zipCode: "7200", },
    { province: "Misamis Occidental", city: "Jimenez", zipCode: "7204", },
    { province: "Misamis Occidental", city: "Lopez Jaena", zipCode: "7208", },
    { province: "Misamis Occidental", city: "Oroquieta", zipCode: "7207", },
    { province: "Misamis Occidental", city: "Ozamiz", zipCode: "7200", },
    { province: "Misamis Occidental", city: "Panaon", zipCode: "7205", },
    { province: "Misamis Occidental", city: "Plaridel", zipCode: "7209", },
    { province: "Misamis Occidental", city: "Sapang Dalaga", zipCode: "7212", },
    { province: "Misamis Occidental", city: "Sinacaban", zipCode: "7203", },
    { province: "Misamis Occidental", city: "Tangub", zipCode: "7214", },
    { province: "Misamis Occidental", city: "Tudela", zipCode: "7202", },
    { province: "Misamis Oriental", city: "Alubijid", zipCode: "9018", },
    { province: "Misamis Oriental", city: "Balingasag", zipCode: "9005", },
    { province: "Misamis Oriental", city: "Balingoan", zipCode: "9011", },
    { province: "Misamis Oriental", city: "Binuangan", zipCode: "9008", },
    { province: "Misamis Oriental", city: "Cagayan de Oro", zipCode: "9000", },
    { province: "Misamis Oriental", city: "Claveria", zipCode: "9004", },
    { province: "Misamis Oriental", city: "El Salvador", zipCode: "9017", },
    { province: "Misamis Oriental", city: "Gingoog", zipCode: "9014", },
    { province: "Misamis Oriental", city: "Gitagum", zipCode: "9020", },
    { province: "Misamis Oriental", city: "Initao", zipCode: "9022", },
    { province: "Misamis Oriental", city: "Jasaan", zipCode: "9003", },
    { province: "Misamis Oriental", city: "Kinoguitan", zipCode: "9010", },
    { province: "Misamis Oriental", city: "Lagonglong", zipCode: "9006", },
    { province: "Misamis Oriental", city: "Laguindingan", zipCode: "9019", },
    { province: "Misamis Oriental", city: "Libertad", zipCode: "9021", },
    { province: "Misamis Oriental", city: "Lugait", zipCode: "9025", },
    { province: "Misamis Oriental", city: "Magsaysay", zipCode: "9015", },
    { province: "Misamis Oriental", city: "Manticao", zipCode: "9024", },
    { province: "Misamis Oriental", city: "Medina", zipCode: "9013", },
    { province: "Misamis Oriental", city: "Naawan", zipCode: "9023", },
    { province: "Misamis Oriental", city: "Opol", zipCode: "9016", },
    { province: "Misamis Oriental", city: "Salay", zipCode: "9007", },
    { province: "Misamis Oriental", city: "Sugbongcogon", zipCode: "9009", },
    { province: "Misamis Oriental", city: "Tagoloan", zipCode: "9001", },
    { province: "Misamis Oriental", city: "Talisayan", zipCode: "9012", },
    { province: "Misamis Oriental", city: "Villanueva", zipCode: "9002", },
    // { province: "Mountain Province", city: "", zipCode: "", },
    { province: "Negros Occidental", city: "Bacolod", zipCode: "6100", },
    { province: "Negros Occidental", city: "Bago", zipCode: "6101", },
    { province: "Negros Occidental", city: "Binalbagan", zipCode: "6107", },
    { province: "Negros Occidental", city: "Cadiz", zipCode: "6121", },
    { province: "Negros Occidental", city: "Calatrava", zipCode: "6126", },
    { province: "Negros Occidental", city: "Candoni", zipCode: "6110", },
    { province: "Negros Occidental", city: "Cauayan", zipCode: "6112", },
    { province: "Negros Occidental", city: "Enrique B. Magalona", zipCode: "6118", },
    { province: "Negros Occidental", city: "Escalante", zipCode: "6124", },
    { province: "Negros Occidental", city: "Himamaylan", zipCode: "6108", },
    { province: "Negros Occidental", city: "Hinigaran", zipCode: "6106", },
    { province: "Negros Occidental", city: "Hinoba-an", zipCode: "6114", },
    { province: "Negros Occidental", city: "Ilog", zipCode: "6109", },
    { province: "Negros Occidental", city: "Isabela", zipCode: "6128", },
    { province: "Negros Occidental", city: "Kabankalan", zipCode: "6100", },
    { province: "Negros Occidental", city: "La Carlota", zipCode: "6130", },
    { province: "Negros Occidental", city: "La Castellana", zipCode: "6131", },
    { province: "Negros Occidental", city: "Manapla", zipCode: "6120", },
    { province: "Negros Occidental", city: "Moises Padilla", zipCode: "6132", },
    { province: "Negros Occidental", city: "Murcia", zipCode: "6129", },
    { province: "Negros Occidental", city: "Pontevedra", zipCode: "6105", },
    { province: "Negros Occidental", city: "Pulupandan", zipCode: "6102", },
    { province: "Negros Occidental", city: "Sagay", zipCode: "6122", },
    { province: "Negros Occidental", city: "Salvador Benedicto", zipCode: "6117", },
    { province: "Negros Occidental", city: "San Carlos", zipCode: "6127", },
    { province: "Negros Occidental", city: "San Enrique", zipCode: "6104", },
    { province: "Negros Occidental", city: "Silay", zipCode: "6116", },
    { province: "Negros Occidental", city: "Sipalay", zipCode: "6113", },
    { province: "Negros Occidental", city: "Talisay", zipCode: "6115", },
    { province: "Negros Occidental", city: "Toboso", zipCode: "6125", },
    { province: "Negros Occidental", city: "Valladolid", zipCode: "6103", },
    { province: "Negros Occidental", city: "Victorias", zipCode: "6119", },
    { province: "Negros Oriental", city: "Amlan (Ayuquitan)", zipCode: "6203", },
    { province: "Negros Oriental", city: "Ayungon", zipCode: "6210", },
    { province: "Negros Oriental", city: "Bacong", zipCode: "6216", },
    { province: "Negros Oriental", city: "Bais", zipCode: "6206", },
    { province: "Negros Oriental", city: "Basay", zipCode: "6222", },
    { province: "Negros Oriental", city: "Bayawan (Tulong)", zipCode: "6221", },
    { province: "Negros Oriental", city: "Bindoy (Payabon)", zipCode: "6209", },
    { province: "Negros Oriental", city: "Canlaon", zipCode: "6223", },
    { province: "Negros Oriental", city: "Dauin", zipCode: "6217", },
    { province: "Negros Oriental", city: "Dumaguete", zipCode: "6200", },
    { province: "Negros Oriental", city: "Guihulngan", zipCode: "6214", },
    { province: "Negros Oriental", city: "Jimalalud", zipCode: "6212", },
    { province: "Negros Oriental", city: "La Libertad", zipCode: "6213", },
    { province: "Negros Oriental", city: "Mabinay", zipCode: "6208", },
    { province: "Negros Oriental", city: "Manjuyod", zipCode: "6208", },
    { province: "Negros Oriental", city: "Pamplona", zipCode: "6205", },
    { province: "Negros Oriental", city: "San Jose", zipCode: "6202", },
    { province: "Negros Oriental", city: "Santa Catalina", zipCode: "6220", },
    { province: "Negros Oriental", city: "Siaton", zipCode: "6219", },
    { province: "Negros Oriental", city: "Sibulan", zipCode: "6201", },
    { province: "Negros Oriental", city: "Tanjay", zipCode: "6204", },
    { province: "Negros Oriental", city: "Tayasan", zipCode: "6211", },
    { province: "Negros Oriental", city: "Valencia (Luzurriaga)", zipCode: "6215", },
    { province: "Negros Oriental", city: "Vallehermoso", zipCode: "6224", },
    { province: "Negros Oriental", city: "Zamboanguita", zipCode: "6218", },
    // { province: "Northern Samar", city: "", zipCode: "", },
    // { province: "Nueva Ecija", city: "", zipCode: "", },
    // { province: "Nueva Vizcaya", city: "", zipCode: "", },
    // { province: "Occidental Mindoro", city: "", zipCode: "", },
    // { province: "Oriental Mindoro", city: "", zipCode: "", },
    // { province: "Palawan", city: "", zipCode: "", },
    // { province: "Pampanga", city: "", zipCode: "", },
    // { province: "Pangasinan", city: "", zipCode: "", },
    { province: "Quezon", city: "Jomalig", zipCode: "4342", },
    { province: "Quezon", city: "Patnanungan", zipCode: "4341", },
    { province: "Quezon", city: "Burdeos", zipCode: "4340", },
    { province: "Quezon", city: "Polillo", zipCode: "4339", },
    { province: "Quezon", city: "Panukulan", zipCode: "4337", },
    { province: "Quezon", city: "General Nakar", zipCode: "4338", },
    { province: "Quezon", city: "Infanta", zipCode: "4336", },
    { province: "Quezon", city: "Real", zipCode: "4335", },
    { province: "Quezon", city: "Mauban", zipCode: "4330", },
    { province: "Quezon", city: "Sampaloc", zipCode: "4329", },
    { province: "Quezon", city: "Lucban", zipCode: "4328", },
    { province: "Quezon", city: "Tayabas", zipCode: "4327", },
    { province: "Quezon", city: "Pagbilao", zipCode: "4302", },
    { province: "Quezon", city: "Lucena", zipCode: "4301", },
    { province: "Quezon", city: "Sariaya", zipCode: "4322", },
    { province: "Quezon", city: "Candelaria", zipCode: "4323", },
    { province: "Quezon", city: "Dolores", zipCode: "4326", },
    { province: "Quezon", city: "Tiaong", zipCode: "4325", },
    { province: "Quezon", city: "San Antonio", zipCode: "4324", },
    { province: "Quezon", city: "Padre Burgos", zipCode: "4303", },
    { province: "Quezon", city: "Agdangan", zipCode: "4304", },
    { province: "Quezon", city: "Unisan", zipCode: "4305", },
    { province: "Quezon", city: "Pitogo", zipCode: "4308", },
    { province: "Quezon", city: "Macalelon", zipCode: "4309", },
    { province: "Quezon", city: "General Luna", zipCode: "4310", },
    { province: "Quezon", city: "Catanauan", zipCode: "4311", },
    { province: "Quezon", city: "Buenavista", zipCode: "4320", },
    { province: "Quezon", city: "San Narciso", zipCode: "4313", },
    { province: "Quezon", city: "Mulanay", zipCode: "4312", },
    { province: "Quezon", city: "San Francisco", zipCode: "4315", },
    { province: "Quezon", city: "San Andres", zipCode: "4314", },
    { province: "Quezon", city: "Perez", zipCode: "4334", },
    { province: "Quezon", city: "Alabat", zipCode: "4333", },
    { province: "Quezon", city: "Quezon", zipCode: "4332", },
    { province: "Quezon", city: "Atimonan", zipCode: "4331", },
    { province: "Quezon", city: "Plaridel", zipCode: "4306", },
    { province: "Quezon", city: "Gumaca", zipCode: "4306", },
    { province: "Quezon", city: "Lopez", zipCode: "4316", },
    { province: "Quezon", city: "Calauag", zipCode: "4318", },
    { province: "Quezon", city: "Guinayangan", zipCode: "4319", },
    { province: "Quezon", city: "Tagkawayan", zipCode: "4321", },
    { province: "Quirino", city: "Aglipay", zipCode: "3403", },
    { province: "Quirino", city: "Cabarroguis", zipCode: "3400", },
    { province: "Quirino", city: "Diffun", zipCode: "3401", },
    { province: "Quirino", city: "Maddela", zipCode: "3404", },
    { province: "Quirino", city: "Nagtipunan", zipCode: "3405", },
    { province: "Quirino", city: "Saguday", zipCode: "3402", },
    { province: "Rizal", city: "Angono", zipCode: "1930", },
    { province: "Rizal", city: "Antipolo", zipCode: "1870", },
    { province: "Rizal", city: "Baras", zipCode: "1970", },
    { province: "Rizal", city: "Binangonan", zipCode: "1940", },
    { province: "Rizal", city: "Cainta", zipCode: "1900", },
    { province: "Rizal", city: "Cardona", zipCode: "1950", },
    { province: "Rizal", city: "Jalajala", zipCode: "1990", },
    { province: "Rizal", city: "Morong", zipCode: "1960", },
    { province: "Rizal", city: "Pililla", zipCode: "1910", },
    { province: "Rizal", city: "Rodriguez", zipCode: "1860", },
    { province: "Rizal", city: "San Mateo", zipCode: "1850", },
    { province: "Rizal", city: "Tanay", zipCode: "1980", },
    { province: "Rizal", city: "Taytay", zipCode: "1920", },
    { province: "Rizal", city: "Teresa", zipCode: "1880", },
    // { province: "Romblon", city: "", zipCode: "", },
    // { province: "Samar", city: "", zipCode: "", },
    // { province: "Sarangani", city: "", zipCode: "", },
    // { province: "Siquijor", city: "", zipCode: "", },
    // { province: "Sorsogon", city: "", zipCode: "", },
    // { province: "South Cotabato", city: "", zipCode: "", },
    { province: "Southern Leyte", city: "Anahawan", zipCode: "6610", },
    { province: "Southern Leyte", city: "Bontoc", zipCode: "6604", },
    { province: "Southern Leyte", city: "Hinunangan", zipCode: "6608", },
    { province: "Southern Leyte", city: "Hinundayan", zipCode: "6609", },
    { province: "Southern Leyte", city: "Libagon", zipCode: "6615", },
    { province: "Southern Leyte", city: "Liloan", zipCode: "6612", },
    { province: "Southern Leyte", city: "Limasawa", zipCode: "6618", },
    { province: "Southern Leyte", city: "Maasin", zipCode: "6600", },
    { province: "Southern Leyte", city: "Macrohon", zipCode: "6601", },
    { province: "Southern Leyte", city: "Malitbog", zipCode: "6603", },
    { province: "Southern Leyte", city: "Padre Burgos", zipCode: "6602", },
    { province: "Southern Leyte", city: "Pintuyan", zipCode: "6614", },
    { province: "Southern Leyte", city: "Saint Bernard", zipCode: "6616", },
    { province: "Southern Leyte", city: "San Francisco", zipCode: "6613", },
    { province: "Southern Leyte", city: "San Juan (Cabalian)", zipCode: "6611", },
    { province: "Southern Leyte", city: "San Ricardo", zipCode: "6617", },
    { province: "Southern Leyte", city: "Silago", zipCode: "6607", },
    { province: "Southern Leyte", city: "Sogod", zipCode: "6606", },
    { province: "Southern Leyte", city: "Tomas Oppus", zipCode: "6605", },
    // { province: "Sultan Kudarat", city: "", zipCode: "", },
    // { province: "Sulu", city: "", zipCode: "", },
    // { province: "Surigao del Norte", city: "", zipCode: "", },
    // { province: "Surigao del Sur", city: "", zipCode: "", },
    // { province: "Tarlac", city: "", zipCode: "", },
    // { province: "Tawi-Tawi", city: "", zipCode: "", },
    { province: "Zambales", city: "Botolan", zipCode: "2202", },
    { province: "Zambales", city: "Cabangan", zipCode: "2203", },
    { province: "Zambales", city: "Candelaria", zipCode: "2212", },
    { province: "Zambales", city: "Castillejos", zipCode: "2208", },
    { province: "Zambales", city: "Iba", zipCode: "2201", },
    { province: "Zambales", city: "Masinloc", zipCode: "2211", },
    { province: "Zambales", city: "Olongapo", zipCode: "2200", },
    { province: "Zambales", city: "Palauig", zipCode: "2210", },
    { province: "Zambales", city: "San Antonio", zipCode: "2206", },
    { province: "Zambales", city: "San Felipe", zipCode: "2204", },
    { province: "Zambales", city: "San Marcelino", zipCode: "2207", },
    { province: "Zambales", city: "San Narciso", zipCode: "2205", },
    { province: "Zambales", city: "Santa Cruz", zipCode: "2213", },
    { province: "Zambales", city: "Subic", zipCode: "2209", },
    // { province: "Zamboanga del Norte", city: "", zipCode: "", },
    // { province: "Zamboanga del Sur", city: "", zipCode: "", },
    // { province: "Zamboanga Sibugay", city: "", zipCode: "", },
    // { province: "Metro Manila", city: "Caloocan", zipCode: "", },
    // { province: "Metro Manila", city: "Las Piñas", zipCode: "", },
    // { province: "Metro Manila", city: "Makati", zipCode: "", },
    // { province: "Metro Manila", city: "Malabon", zipCode: "", },
    // { province: "Metro Manila", city: "Mandaluyong", zipCode: "", },
    // { province: "Metro Manila", city: "Manila City", zipCode: "", },
    // { province: "Metro Manila", city: "Marikina", zipCode: "", },
    // { province: "Metro Manila", city: "Muntinlupa", zipCode: "", },
    // { province: "Metro Manila", city: "Navotas", zipCode: "", },
    // { province: "Metro Manila", city: "Parañaque", zipCode: "", },
    // { province: "Metro Manila", city: "Pasay", zipCode: "", },
    // { province: "Metro Manila", city: "Pasig", zipCode: "", },
    // { province: "Metro Manila", city: "Pateros", zipCode: "", },
    // { province: "Metro Manila", city: "Quezon City", zipCode: "", },
    // { province: "Metro Manila", city: "San Juan", zipCode: "", },
    // { province: "Metro Manila", city: "Taguig", zipCode: "", },
    // { province: "Metro Manila", city: "Valenzuela", zipCode: "", },
]